/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface SentenceEmbeddingsComparisonMatch
 */
export interface SentenceEmbeddingsComparisonMatch {
    /**
     * 
     * @type {number}
     * @memberof SentenceEmbeddingsComparisonMatch
     */
    score?: number;
    /**
     * 
     * @type {number}
     * @memberof SentenceEmbeddingsComparisonMatch
     */
    startOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof SentenceEmbeddingsComparisonMatch
     */
    endOffset?: number;
}

/**
 * Check if a given object implements the SentenceEmbeddingsComparisonMatch interface.
 */
export function instanceOfSentenceEmbeddingsComparisonMatch(value: object): boolean {
    return true;
}

export function SentenceEmbeddingsComparisonMatchFromJSON(json: any): SentenceEmbeddingsComparisonMatch {
    return SentenceEmbeddingsComparisonMatchFromJSONTyped(json, false);
}

export function SentenceEmbeddingsComparisonMatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SentenceEmbeddingsComparisonMatch {
    if (json == null) {
        return json;
    }
    return {
        
        'score': json['score'] == null ? undefined : json['score'],
        'startOffset': json['startOffset'] == null ? undefined : json['startOffset'],
        'endOffset': json['endOffset'] == null ? undefined : json['endOffset'],
    };
}

export function SentenceEmbeddingsComparisonMatchToJSON(value?: SentenceEmbeddingsComparisonMatch | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'score': value['score'],
        'startOffset': value['startOffset'],
        'endOffset': value['endOffset'],
    };
}

